import React, { useEffect, useRef, useState } from 'react';
import * as XLSX from 'xlsx';

import { Link as RouterLink, useSearchParams, useParams, useLocation } from 'react-router-dom';

// materialF
import { styled } from '@mui/material/styles';
import {
  Box,
  MenuItem,
  Typography,
  Container,
  Table,
  Card,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputLabel,
  FormControl,
  Stack,
  Select,
  Divider,
  TextField,
  InputAdornment,
  TableBody,
  LinearProgress,
  Badge,
  IconButton,
  Button,
  Autocomplete,
  Popover
} from '@mui/material';

import '../css/GlobalStyles.css';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import {
  DeviceOrderdButtons,
  MapDeviceWithMerchant,
  MerchantsMoreMenu,
  UpdateMerchantModal
} from '../components/_dashboard/soundbox';
import {
  GetMerchantVpas,
  UnMapMerchant,
  UpdateMerchant,
  UpdateMerchantStatus
} from '../network/Merchants';
import { GetSearchBranches, GetSearchRegions, GetSearchZones } from '../network/AppLevel';
import { GetDeviceDetails } from '../network/Device';

import { convertUTCtoIST } from '../utils/formatTime';

// components
import Page from '../components/Page';

import { useAuth } from '../components/customContextProviders/AuthContext';
import {
  capitalizeFirstLetter,
  flattenMerchantVpaRow,
  parseValidationErrorMessage,
  showFieldValueWithCheck,
  showLanguageLabelUsingCode,
  titleCase
} from '../utils/Utilities';
import { APP_CONSTANTS, MERCHANT_MORE_MENU_ACTIONS } from '../URLConstants';
import DashboardNavbar from '../layouts/dashboard/DashboardNavbar';
import { ConfirmDialog, NoDataAvailable } from '../components/_dashboard/app';
import DashboardSidebar from '../layouts/dashboard/DashboardSidebar';
import { SnackBarAlert, CustomPagination } from '../components/HelperComponents';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: '1px solid currentColor',
      content: '""'
    }
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0
    }
  }
}));

let currentPage = 1;
let isHasMerchantDataHasNextPage = true;

export default function MerchantListAudioCube() {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [isMapMerchantWidthDeviceOpen, setIsMapMerchantWidthDeviceOpen] = useState(false);

  const { sessionUserData, audioCubeAppLevelSettings, userLoginOrg } = useAuth();
  const merchantsTableRef = useRef(null);
  const [organizationSelectedZone, setOrganizationSelectedZone] = useState({
    name: '',
    id: '',
    taxonomyId: ''
  });
  const [organizationSelectedRegion, setOrganizationSelectedRegion] = useState({
    name: '',
    id: '',
    taxonomyId: ''
  });
  const [organizationSelectedBranch, setOrganizationSelectedBranch] = useState(null);
  const [zoneList, setZoneList] = useState([]);
  const [updateMerchantModalOpen, setUpdateMerchantModalOpen] = useState(false);
  const [audioCubeMerchantListData, setAudioCubeMerchantListData] = useState([]);
  const [audioCubeMerchantListDataLoading, setAudioCubeMerchantListDataLoading] = useState(false);
  const [selectedMerchantForAction, setSelectedMerchantForAction] = useState({
    merchant: {},
    action: null
  });
  const [regionsList, setRegionsList] = useState([]);
  const [branchesList, setBranchesList] = useState([]);
  const [filterType, setFilterType] = useState('phone'); // default to 'name'
  const [filterValue, setFilterValue] = useState('');
  const [deviceIdFromImeiSearch, setDeviceIdFromImeiSearch] = useState(null);
  const [type, setType] = useState('all');

  const [isSnackBarAlertOpen, setIsSnackBarAlertOpen] = useState(false);
  const [snackBarMetas, setSnackBarMetas] = useState({
    title: '',
    message: '',
    severity: 'info',
    handleClose: null
  });

  const [openConfirm, setOpenConfirm] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({
    loading: false,
    message: '',
    onConfirm: () => { },
    onCancel: () => setOpenConfirm(false),
    confirmText: ''
  });

  const [isDownloadingExcel, setIsDownloadingExcel] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [dispatchAnchorEl, setDispatchAnchorEl] = useState(null);
  const [paymentInterfaceType, setPaymentInterfaceType] = useState('all');
  const openInfo = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDispatchClick = (event) => {
    setDispatchAnchorEl(event.currentTarget);
  };

  const handleDispatchClose = () => {
    setDispatchAnchorEl(null);
  };

  const openDispatch = Boolean(dispatchAnchorEl);

  const getPaymentInterfaceTypeWhereFilter = () => {
    if (!paymentInterfaceType || paymentInterfaceType === 'all') return {};
    return { paymentInterfaceType: [paymentInterfaceType] };
  };

  function buildMerchantsWhere({
    zoneOfficeId: zoneOverride,
    regionalOfficeId: regionOverride,
    branchId: branchIdOverride,
    merchantStatusType,
    paymentInterfaceWhere
  } = {}) {
    const z = zoneOverride !== undefined ? zoneOverride : organizationSelectedZone?.taxonomyId;
    const r =
      regionOverride !== undefined ? regionOverride : organizationSelectedRegion?.taxonomyId;
    const b = branchIdOverride !== undefined ? branchIdOverride : organizationSelectedBranch;
    const ms = merchantStatusType !== undefined ? merchantStatusType : type;

    let statusWhere = {};
    if (ms === 'assigned') statusWhere = { activated: true };
    else if (ms === 'un-assigned' || ms === 'unassigned') statusWhere = { activated: false };

    const pip =
      paymentInterfaceWhere !== undefined
        ? paymentInterfaceWhere
        : getPaymentInterfaceTypeWhereFilter();

    let searchFilter = {};
    if (filterType === 'imei') {
      if (deviceIdFromImeiSearch) searchFilter = { deviceId: deviceIdFromImeiSearch };
    } else if (filterValue) {
      const lowerCased = filterType === 'vpa' || filterType === 'packageStatus';
      searchFilter = { [filterType]: lowerCased ? filterValue.toLowerCase() : filterValue };
    }

    // merchant-vpa where-clause: zone/region (taxonomy ids) nest under `hierarchy`, the
    // rest stays flat, and the merchant list only shows approved VPAs.
    const hierarchy = {
      ...(z && { zoneOfficeId: z }),
      ...(r && { regionalOfficeId: r })
    };

    return {
      ...(b && { branchId: b }),
      ...pip,
      ...searchFilter,
      ...statusWhere,
      ...(Object.keys(hierarchy).length > 0 && { hierarchy }),
      approvalStatus: 'APPROVED'
    };
  }

  useEffect(() => {
    fetchMerchants(currentPage, 10, buildMerchantsWhere(), 'SEARCH');
    fetchZoneList();
    fetchRegionList();
    fetchBranchesList(organizationSelectedRegion?.id);
    return () => {
      currentPage = 1;
      isHasMerchantDataHasNextPage = true;
      setAudioCubeMerchantListData([]);
    };
  }, []);

  const handleChangePage = (data, customPage) => {
    const searchParamsCbi = buildMerchantsWhere();
    let newPage = page;
    if (data === 'NEXT') newPage += 1;
    else newPage -= 1;

    if (customPage) {
      setPage(customPage);
      fetchMerchants(customPage, 10, searchParamsCbi, 'SEARCH');
      return;
    }
    setPage(newPage);
    fetchMerchants(newPage, 10, searchParamsCbi, 'SEARCH');
  };

  function fetchZoneList() {
    GetSearchZones()
      .then((res) => {
        setZoneList(res?.data);
      })
      .catch(() => { });
  }

  function fetchRegionList(headOfficeId, zoneOfficeId) {
    GetSearchRegions(headOfficeId, zoneOfficeId)
      .then((res) => {
        setRegionsList(res?.data);
      })
      .catch((Err) => { });
  }

  function fetchBranchesList(regionalOfficeId) {
    GetSearchBranches(regionalOfficeId)
      .then((res) => {
        setBranchesList(res?.data);
      })
      .catch((err) => { });
  }

  function fetchMerchants(currentPage, limit, where, type) {
    setAudioCubeMerchantListDataLoading(true);
    GetMerchantVpas(currentPage, limit, where)
      .then((res) => {
        setAudioCubeMerchantListDataLoading(false);
        isHasMerchantDataHasNextPage = res?.data?.hasNextPage;
        const rows = (res?.data?.data || []).map(flattenMerchantVpaRow);

        if (type === 'LOAD') setAudioCubeMerchantListData((prevList) => [...prevList, ...rows]);
        else if (type === 'SEARCH') {
          setAudioCubeMerchantListData([]);
          setAudioCubeMerchantListData(rows);
          if (res?.data && rows.length === 0) {
            setSnackBarMetas((prevState) => ({
              ...prevState,
              title: 'No such Merchant Exists.',
              severity: 'error'
            }));
            setIsSnackBarAlertOpen(true);
          }
        }
      })
      .catch((_error) => {
        setAudioCubeMerchantListDataLoading(false);
        if (type === 'SEARCH') {
          setAudioCubeMerchantListData([]);

          setSnackBarMetas((prevState) => ({
            ...prevState,
            title: 'Failed to fetch merchants. Please try again.',
            severity: 'error'
          }));
          setIsSnackBarAlertOpen(true);
        }
      });
  }

  const handlePaymentInterfaceTypeChange = (selectedType) => {
    currentPage = 1;
    setPage(1);

    const paymentInterfaceWhere =
      !selectedType || selectedType === 'all' ? {} : { paymentInterfaceType: [selectedType] };

    fetchMerchants(1, 10, buildMerchantsWhere({ paymentInterfaceWhere }), 'SEARCH');
  };

  const handleOrganizatioRegionValChange = (event) => {
    const region = event.target.value;
    const regionalOfficeId = event.target.id;
    const { taxonomyId } = event.target;
    setOrganizationSelectedRegion({
      name: region,
      id: regionalOfficeId,
      taxonomyId
    });
    setOrganizationSelectedBranch(null);
    fetchMerchants(
      1,
      10,
      buildMerchantsWhere({ regionalOfficeId: taxonomyId, branchId: null }),
      'SEARCH'
    );
    fetchBranchesList(regionalOfficeId);
  };
  const handleOrganizatioZoneValChange = (event) => {
    const zone = event.target.value;
    const zoneOfficeId = event.target.id;
    const { taxonomyId } = event.target;
    setOrganizationSelectedZone({
      name: zone,
      id: zoneOfficeId,
      taxonomyId
    });
    setOrganizationSelectedRegion(null);
    setOrganizationSelectedBranch(null);
    fetchMerchants(1, 10, buildMerchantsWhere({ zoneOfficeId: taxonomyId, regionalOfficeId: null, branchId: null }), 'SEARCH');
    fetchRegionList('', zoneOfficeId);
    fetchBranchesList('');
  };

  const handleOrganizatioBranchValChange = (event) => {
    const branchId = event.target.value;
    setOrganizationSelectedBranch(branchId);
    fetchMerchants(1, 10, buildMerchantsWhere({ branchId }), 'SEARCH');
  };

  function isValidVPA(vpa) {
    const vpaRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9]+$/;
    return vpaRegex.test(vpa);
  }

  const triggerSearchCbi = async (value) => {
    const enteredValue = value.trim();
    currentPage = 1;
    setPage(1);

    if (filterType === 'imei' && !enteredValue) {
      setDeviceIdFromImeiSearch(null);
    }

    const searchParamsCbi = buildMerchantsWhere();

    const searchParams = {
      branch: organizationSelectedBranch,
      regionalOfficeId: organizationSelectedRegion?.id
    };

    // buildMerchantsWhere reads filterValue from state; the value searched here is the
    // source of truth, so drop that key and set it explicitly below.
    delete searchParamsCbi[filterType];
    delete searchParamsCbi.deviceId;

    if (enteredValue) {
      if (filterType === 'vpa') {
        if (!isValidVPA(enteredValue)) {
          setSnackBarMetas((prevState) => ({
            ...prevState,
            title: 'Please enter a valid VPA.',
            severity: 'error'
          }));
          setIsSnackBarAlertOpen(true);
          return;
        }
        searchParams.vpa = enteredValue.toLowerCase();
        searchParamsCbi.vpa = enteredValue.toLowerCase();
      } else if (filterType === 'imei') {
        try {
          const res = await GetDeviceDetails({ imei: enteredValue });
          const device = res?.data?.data?.[0];
          const resolvedDeviceId = device?.id;
          if (!resolvedDeviceId) {
            setDeviceIdFromImeiSearch(null);
            setSnackBarMetas((prevState) => ({
              ...prevState,
              title: 'No device found for the entered IMEI.',
              severity: 'error'
            }));
            setIsSnackBarAlertOpen(true);
            return;
          }
          delete searchParamsCbi.imei;
          searchParamsCbi.deviceId = resolvedDeviceId;
          setDeviceIdFromImeiSearch(resolvedDeviceId);
        } catch (_err) {
          setDeviceIdFromImeiSearch(null);
          setSnackBarMetas((prevState) => ({
            ...prevState,
            title: 'Failed to search device by IMEI. Please try again.',
            severity: 'error'
          }));
          setIsSnackBarAlertOpen(true);
          return;
        }
      } else if (filterType === 'details.uniqueRef') {
        searchParams['details.uniqueRef'] = enteredValue;
        searchParamsCbi['details.uniqueRef'] = enteredValue;
      } else if (filterType === 'name') {
        searchParams.name = enteredValue;
        searchParamsCbi.name = enteredValue;
      } else if (filterType === 'phone') {
        searchParams.phone = enteredValue;
        searchParamsCbi.phone = enteredValue;
      } else if (filterType === 'packageStatus') {
        searchParams.packageStatus = enteredValue.toLowerCase();
        searchParamsCbi.packageStatus = enteredValue.toLowerCase();
      }
    }

    fetchMerchants(currentPage, 10, searchParamsCbi, 'SEARCH');
  };

  const handleMerchantMoreMenuClick = (action, merchantData) => {
    switch (action) {
      case MERCHANT_MORE_MENU_ACTIONS?.UPDATE_MERCHANT: {
        setUpdateMerchantModalOpen(true);
        setSelectedMerchantForAction({
          ...selectedMerchantForAction,
          merchant: merchantData,
          action: 'update_merchant'
        });

        break;
      }
      case MERCHANT_MORE_MENU_ACTIONS?.UNMAP_MERCHANT: {
        setDialogConfig({
          loading: false,
          message: `Are you sure you want to unmap merchant with it's device?`,
          onConfirm: () => {
            deAttachMerchant(merchantData);
          },
          onCancel: () => {
            setOpenConfirm(false);
          },
          confirmText: 'Yes',
          cancelText: 'No'
        });

        setOpenConfirm(true);

        break;
      }
      case MERCHANT_MORE_MENU_ACTIONS?.MAP_MERCHANT: {
        setSelectedMerchantForAction({
          ...selectedMerchantForAction,
          merchant: merchantData,
          action: 'activate'
        });
        setIsMapMerchantWidthDeviceOpen(true);
        break;
      }
      default: {
        return '';
      }
    }
  };

  function onMapMerchantWithDeviceAction(action, msg) {
    if (action === APP_CONSTANTS?.MERCHANT_MAPPING_SUCCESSFULL) {
      currentPage = 1;
      fetchMerchants(currentPage, 10, buildMerchantsWhere(), 'SEARCH');
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: msg,
        severity: 'success'
      }));
      setIsSnackBarAlertOpen(true);
    } else {
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: parseValidationErrorMessage(msg),
        severity: 'error'
      }));
      setIsSnackBarAlertOpen(true);
    }
  }

  function deAttachMerchant(merchantData) {
    setDialogConfig((prev) => ({
      ...prev,
      loading: true
    }));
    UnMapMerchant(merchantData?.vpa)
      .then((res) => {
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: 'Merchant un-mapped successfully!',
          severity: 'success'
        }));
        setIsSnackBarAlertOpen(true);
        setDialogConfig((prev) => ({
          ...prev,
          loading: false
        }));
        setOpenConfirm(false);
        fetchMerchants(currentPage, 10, buildMerchantsWhere(), 'SEARCH');
      })
      .catch((err) => {
        setSnackBarMetas((prevState) => ({
          ...prevState,
          title: parseValidationErrorMessage(err),
          severity: 'error'
        }));
        setIsSnackBarAlertOpen(true);
        setDialogConfig((prev) => ({
          ...prev,
          loading: false
        }));
        setOpenConfirm(false);
      });
  }

  function onUpdateMerchantAction(action, msg) {
    if (action === APP_CONSTANTS?.MERCHANT_UPDATE_SUCCESSFULL) {
      currentPage = 1;
      fetchMerchants(currentPage, 10, buildMerchantsWhere(), 'SEARCH');

      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: msg,
        severity: 'success'
      }));
      setIsSnackBarAlertOpen(true);
    } else {
      setSnackBarMetas((prevState) => ({
        ...prevState,
        title: parseValidationErrorMessage(msg),
        severity: 'error'
      }));
      setIsSnackBarAlertOpen(true);
    }
  }

  async function handleDownloadExcel() {
    setIsDownloadingExcel(true);
    try {
      const searchParamsCbi = buildMerchantsWhere();

      const res = await GetMerchantVpas(page, 10, searchParamsCbi);
      const data = (res?.data?.data || []).map(flattenMerchantVpaRow);

      const worksheetData = data.map((row) => ({
        Name: row?.name || '',
        Phone: row?.phone || '',
        VPA: row?.vpa || '',
        MID: row?.mid || '',
        'Device Status': row?.activated ? 'Mapped' : 'Not-Mapped',
        Language: row?.language || '',
        Address: row?.address || '',
        City: row?.city || '',
        State: row?.state || '',
        Pincode: row?.pincode || '',
        // Branch: row?.branch || '',
        'Branch ID': row?.branchId || '',
        // Region: row?.region || '',
        'Package Status': row?.packageStatus || '',
        'AWB Number': row?.awbNumber || '',
        'Partner Name': row?.partnerName || '',
        'Vendor Name': row?.vendorName || '',
        'Account Number (Unique Ref)': row?.details?.uniqueRef || '',
        MCC: row?.details?.mcc || '',
        'Account Type': row?.details?.accountType || '',
        'Is Verified': row?.details?.isVerified || '',
        'Merchant Genre': row?.details?.merchantGenre || '',
        'Onboarding Type': row?.details?.onBoardingType || '',
        'Payment Interface': [].concat(row?.paymentInterfaceType || []).join(', '),
        Role: row?.role || '',
        'Created At': row?.createdAt ? convertUTCtoIST(row?.createdAt) : '',
        // 'Head Office': row?.branchData?.headOfficeName || '',
        // 'Zone Office': row?.branchData?.zoneOfficeName || '',
        // 'Regional Office': row?.branchData?.regionalOfficeName || ''
      }));

      const ws = XLSX.utils.json_to_sheet(worksheetData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Merchants');
      XLSX.writeFile(wb, 'MerchantsList.xlsx');
    } catch (err) {
      setSnackBarMetas((prev) => ({
        ...prev,
        title: 'Failed to download. Please try again.',
        severity: 'error'
      }));
      setIsSnackBarAlertOpen(true);
    } finally {
      setIsDownloadingExcel(false);
    }
  }

  function handleTypeChange(nextMerchantStatus) {
    fetchMerchants(
      page,
      10,
      buildMerchantsWhere({ merchantStatusType: nextMerchantStatus }),
      'SEARCH'
    );
  }

  const deviceOrderButtonsProps = {
    onDownloadExcel: handleDownloadExcel,
    isDownloadingExcel
  };

  return (
    <Page title="Merchants">
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} data-testid="dashboard-navbar" />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />

      <Container maxWidth="false">
        <DeviceOrderdButtons {...deviceOrderButtonsProps} />
        <Card>
          <Stack
            direction={{ md: 'column', xs: 'column', sm: 'column', lg: 'row' }}
            // alignItems="flex-start"
            spacing={3}
            justifyContent={{ md: 'flex-start', lg: 'space-between' }}
            sx={{ p: 2 }}
            mt={1}
            mb={1}
          >
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
              {(sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_ADMIN ||
                sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN) && (
                  <>
                    <FormControl size="small" sx={{ minWidth: 60 }}>
                      <Typography sx={{ fontSize: 16, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                        Filter By
                      </Typography>
                    </FormControl>

                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <Autocomplete
                        id="zone-autocomplete"
                        size="small"
                        options={zoneList || []}
                        getOptionLabel={(option) => option?.name || option || ''}
                        value={organizationSelectedZone?.name ? { name: organizationSelectedZone?.name } : null}
                        onChange={(event, newValue) => {
                          handleOrganizatioZoneValChange({
                            target: {
                              value: newValue?.name || newValue || null,
                              taxonomyId: newValue?.taxonomyId || null,
                              id: newValue?.id || null
                            }
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Zone" variant="outlined" />
                        )}
                      />
                    </FormControl>

                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <Autocomplete
                        id="region-autocomplete"
                        size="small"
                        options={regionsList || []}
                        getOptionLabel={(option) => option?.name || option || ''}
                        value={
                          organizationSelectedRegion?.name ? { name: organizationSelectedRegion?.name } : null
                        }
                        onChange={(event, newValue) => {
                          handleOrganizatioRegionValChange({
                            target: {
                              value: newValue?.name || newValue || null,
                              id: newValue?.id || null,
                              taxonomyId: newValue?.taxonomyId || null
                            }
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Region" variant="outlined" />
                        )}
                      />
                    </FormControl>
                  </>
                )}

              <Stack direction="row" spacing={2} alignItems="center">
                {/* Branch Selector */}
                {(sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_ADMIN ||
                  sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN) && (
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <Autocomplete
                        id="branch-autocomplete"
                        size="small"
                        options={branchesList || []}
                        getOptionLabel={(option) => option?.branchId || option?.id || option || ''}
                        value={
                          organizationSelectedBranch ? { branchId: organizationSelectedBranch } : null
                        }
                        onChange={(event, newValue) => {
                          handleOrganizatioBranchValChange({
                            target: { value: newValue?.branchId ?? null }
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Branch" variant="outlined" />
                        )}
                      />
                    </FormControl>
                  )}

                <FormControl size="small" sx={{ minWidth: 150 }}>
                  <InputLabel>Merchant Status</InputLabel>
                  <Select
                    value={type}
                    onChange={(e) => {
                      setType(e.target.value);
                      handleTypeChange(e.target.value);
                    }}
                    label="Merchant Status"
                    data-cy="merchant-status-select"
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="assigned">Mapped</MenuItem>
                    <MenuItem value="un-assigned">Unmapped</MenuItem>
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: 150 }}>
                  <InputLabel>
                    {process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID ===
                      APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER
                      ? 'Soundbox Type'
                      : 'Payment Interface Type'}
                  </InputLabel>
                  <Select
                    value={paymentInterfaceType}
                    onChange={(e) => {
                      setPaymentInterfaceType(e.target.value);
                      handlePaymentInterfaceTypeChange(e.target.value);
                    }}
                    label={
                      process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID ===
                        APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER
                        ? 'Soundbox Type'
                        : 'Payment Interface Type'
                    }
                    data-cy="payment-interface-type-select"
                  >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="static_qr_soundbox">Static QR Soundbox</MenuItem>
                    <MenuItem value="dynamic_qr_soundbox">Dynamic QR Soundbox</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            </Stack>

            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
              <FormControl size="small" sx={{ minWidth: 200 }}>
                <InputLabel>Search By</InputLabel>
                <Select
                  value={filterType}
                  onChange={(e) => {
                    setFilterType(e.target.value);
                    setFilterValue('');
                    setDeviceIdFromImeiSearch(null);
                  }}
                  label="Search By"
                  data-cy="merchant-search-by-select"
                >
                  <MenuItem value="name">Merchant Name</MenuItem>
                  <MenuItem value="vpa">Merchant VPA</MenuItem>
                  <MenuItem value="imei">Device IMEI</MenuItem>
                  <MenuItem value="phone">Merchant Phone No.</MenuItem>
                  {userLoginOrg !== APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER && (
                    <MenuItem value="packageStatus">Dispatch Status</MenuItem>
                  )}
                  {userLoginOrg === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER && (
                    <MenuItem value="details.uniqueRef">Account Number</MenuItem>
                  )}
                </Select>
              </FormControl>

              <Typography> = </Typography>

              <FormControl size="small" sx={{ width: 200 }}>
                {filterType === 'packageStatus' ? (
                  <>
                    <InputLabel id="package-status-label">Select Status</InputLabel>
                    <Select
                      value={filterValue}
                      onChange={(e) => {
                        setFilterValue(e.target.value);
                        triggerSearchCbi(e.target.value);
                      }}
                      displayEmpty
                      labelId="package-status-label"
                      label="Select Status"
                      data-cy="package-status-select"
                    >
                      <MenuItem value="intransit">In Transit</MenuItem>
                      <MenuItem value="delivered">Delivered</MenuItem>
                      <MenuItem value="manifested">Manifested</MenuItem>
                      <MenuItem value="pending">Pending</MenuItem>
                    </Select>
                  </>
                ) : (
                  <TextField
                    size="small"
                    label="Enter Value"
                    value={filterValue}
                    onChange={(e) => setFilterValue(e.target.value)}
                    InputProps={{
                      inputProps: {
                        'data-testid': 'merchantName' // ✅ moved here to avoid eslint duplicate-props
                      },
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => triggerSearchCbi(filterValue)}>
                            <SearchOutlinedIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        triggerSearchCbi(filterValue);
                      }
                    }}
                  />
                )}
              </FormControl>
            </Stack>
          </Stack>
          <Divider sx={{ m: 1 }} />

          {audioCubeMerchantListData !== null && audioCubeMerchantListData !== undefined ? (
            <>
              <TableContainer
                sx={{ maxHeight: '60vh', overflowY: 'scroll', minHeight: '60vh' }}
                ref={merchantsTableRef}
                data-cy="merchants-table-container"
              >
                <Table stickyHeader data-cy="merchants-table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        sx={{
                          minWidth: '14vw',
                          fontWeight: 900,
                          position: 'sticky',
                          left: 0,
                          background: 'white',
                          zIndex: 4,
                          boxShadow: '2px 0 5px -5px rgba(0,0,0,0.8)'
                        }}
                      >
                        VPA
                      </TableCell>
                      <TableCell align="left" sx={{ minWidth: '15vw', fontWeight: 900 }}>
                        Merchant Details
                      </TableCell>

                      <TableCell align="left" sx={{ minWidth: '8vw', fontWeight: 900 }}>
                        Device <br />
                        Status
                        <IconButton size="small" onClick={handleClick}>
                          <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                        <Popover
                          open={openInfo}
                          anchorEl={anchorEl}
                          onClose={handleClose}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left'
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                          }}
                        >
                          <Typography sx={{ p: 2, maxWidth: 250, fontSize: '12px' }}>
                            <b>Active</b> – Already mapped with a Device. <br />
                            <b>Inactive</b> – Yet to be mapped with a Device.
                          </Typography>
                        </Popover>
                      </TableCell>
                      <TableCell align="left" sx={{ minWidth: '8vw', fontWeight: 900 }}>
                        Dispatch
                        <br />
                        Details
                        <IconButton size="small" onClick={handleDispatchClick}>
                          <InfoOutlinedIcon fontSize="small" />
                        </IconButton>
                        <Popover
                          open={openDispatch}
                          anchorEl={dispatchAnchorEl}
                          onClose={handleDispatchClose}
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left'
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left'
                          }}
                        >
                          <Typography sx={{ p: 2, maxWidth: 300, fontSize: '12px' }}>
                            <b>Manifested</b> – The shipment has been assigned to a delivery partner
                            and is ready for pickup.
                            <br />
                            <br />
                            <b>In Transit</b> – The shipment is currently on its way to the
                            destination.
                            <br />
                            <br />
                            <b>Delivered</b> – The shipment has successfully reached the recipient.
                            <br />
                            <br />
                            <b>Pending</b> – The shipment is awaiting processing.
                          </Typography>
                        </Popover>
                      </TableCell>
                      <TableCell align="left" sx={{ minWidth: '7vw', fontWeight: 900 }}>
                        Account No
                      </TableCell>
                      {/* <TableCell align="left" sx={{ minWidth: '8vw', fontWeight: 900 }}>
                        Region
                      </TableCell> */}
                      <TableCell align="left" sx={{ minWidth: '7vw', fontWeight: 900 }}>
                        Branch ID
                      </TableCell>
                      <TableCell align="left" sx={{ minWidth: '13vw', fontWeight: 900 }}>
                        Device Requested Date
                      </TableCell>
                      <TableCell align="left" sx={{ minWidth: '5vw', fontWeight: 900 }}>
                        &nbsp;
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {audioCubeMerchantListData?.map((row) => (
                      <TableRow
                        key={row?.id}
                        hover
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        tabIndex={-1}
                        data-cy="merchant-row"
                      >
                        {/* <TableCell sx={{ textAlign: 'left !important' }} align="left" className="merchantTableListLabel" scope="row" > */}
                        <TableCell
                          align="left"
                          sx={{
                            minWidth: '14vw',
                            fontWeight: 900,
                            position: 'sticky',
                            left: 0,
                            background: 'white',
                            zIndex: 1,
                            textAlign: 'left !important',
                            boxShadow: '2px 0 5px -5px rgba(0,0,0,0.8)',
                            cursor: 'pointer'
                          }}
                          className="merchantTableListLabel"
                          scope="row"
                        >
                          <RouterLink
                            to={`/dashboard/soundboxdevicedetails/${row?.id}/${row?.organizationId}`}
                            style={{
                              color: '#5c5574',
                              fontWeight: 900,
                              textDecoration: 'underline'
                            }}
                          >
                            {row?.vpa}
                          </RouterLink>
                        </TableCell>
                        <TableCell>
                          <Typography className="merchantTableListLabel">
                            {titleCase(row?.name)}{' '}
                          </Typography>
                          <Typography className="merchantTableListLabel">{row?.phone} </Typography>
                        </TableCell>
                        <TableCell className="merchantTableListLabel">
                          {showFieldValueWithCheck(row?.activated ? 'Mapped' : 'Not-Mapped')}
                        </TableCell>

                        <TableCell className="merchantTableListLabel">
                          <Typography className="merchantTableListLabel">
                            {capitalizeFirstLetter(row?.packageStatus) || '---'}{' '}
                          </Typography>
                          <Typography className="merchantTableListLabel">
                            {row?.awbNumber || '---'}{' '}
                          </Typography>
                        </TableCell>
                        <TableCell className="merchantTableListLabel">
                          {row?.details?.uniqueRef || '---'}
                        </TableCell>
                        {/* <TableCell className="merchantTableListLabel">
                          {titleCase(row?.region) || '---'}
                        </TableCell> */}
                        <TableCell className="merchantTableListLabel">
                          {row?.branchId || '---'}
                        </TableCell>
                        <TableCell className="merchantTableListLabel">
                          {/* {row?.activated ? convertUTCtoIST(row?.createdAt) : '---'}{' '} */}
                          {convertUTCtoIST(row?.createdAt)}
                        </TableCell>

                        {sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_ADMIN && (
                          <TableCell className="merchantTableListLabel">
                            <MerchantsMoreMenu
                              handleUser={row}
                              handleClicks={(e) => handleMerchantMoreMenuClick(e, row)}
                            />
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                    {audioCubeMerchantListData?.length === 0 &&
                      audioCubeMerchantListDataLoading !== true && (
                        <TableRow>
                          <TableCell colSpan={10}>
                            <NoDataAvailable />
                          </TableCell>
                        </TableRow>
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
              <CustomPagination
                page={page}
                handleNextPage={() => handleChangePage('NEXT')}
                handlePreviousPage={handleChangePage}
                hasNextPage={isHasMerchantDataHasNextPage}
                data={audioCubeMerchantListData}
                setPage={setPage}
              />
            </>
          ) : null}
          {audioCubeMerchantListDataLoading ? <LinearProgress color="success" /> : null}
        </Card>
      </Container>

      <UpdateMerchantModal
        open={updateMerchantModalOpen}
        handleClose={() => setUpdateMerchantModalOpen(false)}
        merchantData={selectedMerchantForAction}
        onUpdate={(action, msg) => onUpdateMerchantAction(action, msg)}
      />

      <SnackBarAlert
        open={isSnackBarAlertOpen}
        title={snackBarMetas?.title}
        message={snackBarMetas?.message}
        severity={snackBarMetas?.severity}
        handleClose={() => setIsSnackBarAlertOpen(false)}
      />
      <ConfirmDialog
        open={openConfirm}
        message={dialogConfig.message}
        onCancel={dialogConfig.onCancel}
        onConfirm={dialogConfig.onConfirm}
        loading={dialogConfig?.loading}
        note={dialogConfig?.note}
        confirmText={dialogConfig?.confirmText}
        cancelText={dialogConfig?.cancelText}
      />
      <MapDeviceWithMerchant
        opneAssignedModal={isMapMerchantWidthDeviceOpen}
        handleClose={() => setIsMapMerchantWidthDeviceOpen(false)}
        onAction={(action, msg) => onMapMerchantWithDeviceAction(action, msg)}
        merchantData={selectedMerchantForAction}
      />
    </Page>
  );
}
